import { http } from "../client";
import { mapTrackObject } from "../tracks/map";
export var getTimetablePlaylistForToday = function (id) {
    return http.api
        .get("timetables/".concat(id, "/today_playlist"))
        .then(function (response) { return response.data.data.entries.map(mapTrackObject); });
};
